import useFetchApi from "@/api/hooks/useFetchApi";
import useFetchGroup from "@/api/hooks/useFetchGroup";
import usePageData from "@/api/hooks/usePageData";
import MinimarLogo from "@/components/MinimarLogo/MinimarLogo";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {

    const {
        page,
        data,
        isLoading,
        localization
    } = usePageData("/");
    const {
        data: pages
    } = useFetchApi({
        url: "/v1/pages?locale=tr",
        service: "CMS_PROC"
    });


    return (
        <>
            <div className="colourfull-row"></div>
            <footer id="footer" className="light">

                <div className="container">

                    <div className="row">

                        <div className="col-md-4">

                            <div className="footer-widget">

                                <h4><span>
                                    Minimar
                                </span></h4>

                                <ul className="footer-nav list-unstyled clearfix">
                                    {
                                        pages?.filter((x: any) => !x.tags.includes("no-nav"))
                                        .map((page: any) => {
                                            return (
                                                <li key={page._id}>
                                                    <Link
                                                        to={`${page.slug}`}
                                                        className="footer-link"
                                                    >
                                                        <i className="fa fa-long-arrow-right"></i>
                                                        {page.name}
                                                    </Link>
                                                </li>
                                            )
                                        })
                                    }

                                </ul>

                                <Link
                                    target="_blank"
                                    to={`https://www.kvkk.info.tr/clients/minimar`}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}
                                >
                                    <i className="fa fa-long-arrow-right"></i>
                                    Kişisel Verilerin Korunması
                                </Link>

                            </div>

                        </div>


                        <div className="col-md-4">

                            <div className="footer-widget">

                                <h4><span>
                                    {localization?.dict["footer.highlight.title"].value}
                                </span></h4>

                                <div className="twitter-widget">

                                    {data?.Products?.map((product: any) => {
                                        return (
                                            <div key={product._id}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '10px'
                                                }}
                                            >
                                                <img
                                                    src={product.image}
                                                    alt={product.title}
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        borderRadius: '50%'
                                                    }}
                                                />
                                                <p
                                                    style={{
                                                        marginLeft: '10px'
                                                    }}
                                                >
                                                    <Link to={`${localization?.dict["product.examples.readmore.link"].value + product.category.slug + "/" + product.sef_url}`}>
                                                        {product.title}
                                                    </Link>
                                                </p>
                                            </div>
                                        )

                                    })}
                                </div>

                            </div>

                        </div>

                        <div className="col-md-4">

                            <div className="footer-widget">

                                <h4><span>
                                    {localization?.dict["footer.contact.title"].value}
                                </span></h4>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: localization?.dict["footer.contact.content"].value
                                    }}
                                >

                                </p>

                                <div className="contact-widget">

                                    <i className="fa fa-globe"></i>
                                    <p><a href={"mailto:" + localization?.dict["footer.contact.email"].value}>
                                        {localization?.dict["footer.contact.email"].value}
                                    </a></p>
                                    <i className="fa fa-mobile"></i>
                                    <p

                                        className="phone-number">
                                        <a
                                            href={`tel:${localization?.dict["footer.contact.phone"].value}`}
                                        >
                                            {localization?.dict["footer.contact.phone"].value}
                                        </a>
                                    </p>
                                </div>


                            </div>

                        </div>

                    </div>
                    <hr
                        style={{
                            borderColor: 'rgba(0,0,0, 0.4)'
                        }}
                    />
                    <div className="col-md-12">
                        <div className="row" style={{
                            alignItems: "center", display: "flex", flexDirection: "row"
                        }}>
                            <div className="col-md-4 col-sm-12" style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                                <MinimarLogo logo_name="minimar" size="small" />
                            </div>
                            <div className="col-md-4 col-sm-12" style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                                <MinimarLogo logo_name="bd" size="small" />
                            </div>
                            <div className="col-md-4 col-sm-12" style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                                <MinimarLogo logo_name="bard" size="small" />
                            </div>
                        </div>
                        <p className="text-center" style={{ marginTop: "20px" }}>
                            &copy; {moment().year()} Minimar. All Rights Reserved. Created by <a target="_blank" href="https://www.egebilgi.com.tr">Egebilgi Yazılım</a>
                        </p>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;